import React from "react";
import { Helmet } from "react-helmet";
import {
  Card,
  CardActionArea,
  Grid,
  Container,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomAppBar from "../../components/AppBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";
const useStyles = makeStyles(() => ({
  carStyle: {
    border: "1px solid #A5A5A5 !important",
  },
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "20px !important",
  },
}));
export default function FarmerProfileMain() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const buttons = [
    {
      label: t("My Farms"),
      type: "MyFarm",
      route: "/farmer/farms",
    },
    {
      label: t("My Crops"),
      type: "MyCrop",
      route: "/farmer/crops",
    },
    {
      label: t("Fertilizer"),
      type: "Fertilizer",
      route: "/farmer/persicide-fertilizers",
    },
    {
      label: t("Lab Test"),
      type: "LabTest",
      route: "/farmer/lab-tests",
    },
    {
      label: t("Harvests"),
      type: "Harvest",
      route: "/farmer/harvests",
    },
    // {
    //   label: t("Profile"),
    //   type: "Profile",
    //   route: "/farmer/profile",
    // },
    {
      label: t("Advisory"),
      type: "Advisory",
      route: "/farmer/advisory",
    },
    {
      label: t("Decarbonization"),
      type: "Decarbonization",
      route: "/decarbonization",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Farmer Profile - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <Grid container spacing={2}>
          {buttons.map((button, index) => (
            <Grid
              item
              xs={button.type === "Decarbonization" ? 12 : 6}
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                variant="outlined"
                style={{ width: "100%", height: 162 }}
                className={classes.carStyle}
              >
                <CardActionArea
                  onClick={() => navigate(button.route)}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon type={button.type} />
                  <div>
                    <Typography className={classes.cardTitle}>
                      {button.label}
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
